import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'fuse-delete-dialog',
    templateUrl: './delete-dialog.component.html',
    styleUrls: ['./delete-dialog.component.scss'],
    standalone: false
})
export class FuseDeleteDialogComponent implements OnInit
{
    public confirmMessage: string;
    public titleMessage: string;
    public dialogData: string;

    constructor(public dialogRef: MatDialogRef<FuseDeleteDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data)
    {
      this.confirmMessage = data.message;
      this.titleMessage = data.title;
      this.dialogData = data.data;
      console.log(this.dialogData);
    }

    ngOnInit()
    {
    }

}
